import React from 'react';

import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const QuickActionsGrid = ({ onUploadClick }) => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 1,
      title: 'Add New User',
      description: 'Create user account and send invitation',
      icon: 'UserPlus',
      iconColor: 'text-success',
      bgColor: 'bg-success/10',
      action: () => navigate('/user-management')
    },
    {
      id: 2,
      title: 'Approve Content',
      description: 'Review pending content submissions',
      icon: 'CheckCircle',
      iconColor: 'text-primary',
      bgColor: 'bg-primary/10',
      action: () => console.log('Navigate to content approval')
    },
    {
      id: 3,
      title: 'Upload Assets',
      description: 'Add new marketing assets to library',
      icon: 'Upload',
      iconColor: 'text-accent',
      bgColor: 'bg-accent/10',
      action: () => onUploadClick?.()
    },
    {
      id: 4,
      title: 'Create Campaign',
      description: 'Launch new marketing campaign',
      icon: 'Rocket',
      iconColor: 'text-warning',
      bgColor: 'bg-warning/10',
      action: () => navigate('/email-campaigns')
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {quickActions?.map((action) => (
        <div
          key={action?.id}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-250 cursor-pointer group"
          onClick={action?.action}
        >
          <div className={`w-14 h-14 rounded-lg flex items-center justify-center ${action?.bgColor} mb-4 group-hover:scale-110 transition-transform`}>
            <Icon name={action?.icon} size={28} className={action?.iconColor} />
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">{action?.title}</h3>
          <p className="text-sm text-muted-foreground font-caption">{action?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default QuickActionsGrid;